import React from "react";
import { Link } from "react-router-dom";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Button from "material-ui/Button";
import Typography from "material-ui/Typography";
import Select from "material-ui/Select";
import Checkbox from "material-ui/Checkbox";
import Icon from "material-ui/Icon";
import Tooltip from "material-ui/Tooltip";
import Menu, { MenuItem } from "material-ui/Menu";
import Radio, { RadioGroup } from "material-ui/Radio";
import { FormLabel, FormControl, FormControlLabel } from "material-ui/Form";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

import ListAttachments from "../../common/jobandtestattachments/list";
import UploadAttachment from "../../common/jobandtestattachments/add";
import { infoData } from "./infoenum";
import { isSignalTEKQTType, isNaviTEKType } from "../../../common/utils"

class SignaltekResultsHeader extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null,
      jobAttachmentsModal: false,
      uploadModal: false,
      jobid: null,
      testid: null
    };
  }

  handleClick = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  showAttachments = e => {
    e.preventDefault();
    this.setState({
      jobAttachmentsModal: true
    });
  };

  hideAttachments = e => {
    this.setState({
      jobid: null,
      testid: null,
      jobAttachmentsModal: false
    });
  };

  closeModal = reset => {
    this.setState({
      jobid: null,
      testid: null,
      jobAttachmentsModal: false
    });
  };

  showUplaodModal = () => {
    this.setState({
      uploadModal: true
    });
  };

  hideUplaodModal = () => {
    this.setState({
      uploadModal: false
    });
  };

  uploadFile = file => {
    const { jobid, testid } = this.props;
    const { uploadAttachment } = this.props;
    uploadAttachment(file, jobid, testid);
  };

  renderValue = (translate, subtest) => {
    const isNaviTEK = this.props.job && isNaviTEKType(this.props.job.deviceid);
    const isSTQT = this.props.job && isSignalTEKQTType(this.props.job.deviceid);
    if ((isNaviTEK || isSTQT) && subtest === "FiberLengthLoss") {
      return isNaviTEK ? translate("fiberlength") : translate("fiberqualification");
    }
    return subtest.startsWith("qualification_") ? translate(subtest) : subtest;
  }

  getSubtestType = selectedValue => {
    let subtestType = infoData.find(o => o.name === selectedValue);
    if (subtestType && subtestType.id.startsWith("qualification_")) {
      return subtestType.id;
    }
    return selectedValue;
  }

  render() {
    const {
      classes,
      translate,
      results,
      job,
      nextTestId,
      previousTestId,
      currentTestIndex,
      total,
      subtest,
      handleChartLineChange,
      handleChartMeasurementChange,
      handleChartMeasurementUnitChange,
      handleChartMeasurementTypeChange,
      handleShowMargin,
      handleWiremapStandardChange,
      chartLineStyle,
      chartMeasurement,
      chartMeasurementUnit,
      chartMeasurementType,
      wiremapStandard,
      showMargin,
      attachments,
      getAttachments,
      uploadAttachment,
      deleteAttachment,
      attachmentDownload,
      jobid,
      testid,
      clearAttachments,
      fileUploadSettings,
    } = this.props;

    let $jobAttachmentsModal = this.state.jobAttachmentsModal ? (
      <ListAttachments
        translate={translate}
        close={this.closeModal}
        jobid={jobid}
        testid={testid}
        attachments={attachments}
        getAttachments={getAttachments}
        hideUplaodModal={this.hideUplaodModal}
        showUplaodModal={this.showUplaodModal}
        deleteAttachment={deleteAttachment}
        attachmentDownload={attachmentDownload}
        clearAttachments={clearAttachments}
      />
    ) : null;

    let $fileUploadModal = this.state.uploadModal ? (
      <UploadAttachment
        translate={translate}
        jobid={jobid}
        testid={testid}
        hideUplaodModal={this.hideUplaodModal}
        uploadFile={this.uploadFile}
        fileUploadSettings={fileUploadSettings}
      />
    ) : null;

    let isNavitek = job && isNaviTEKType(job.deviceid);

    const { anchorEl } = this.state;
    let subtests = [];
    if (this.props.results.data.qualification) {
      subtests.push({ type: "qualification" });
      if (this.props.impersonating) {
        subtests.push({ type: "qualification_il" });
        subtests.push({ type: "qualification_rl" });
        subtests.push({ type: "qualification_next" });
      }
    }
    else if (this.props.results.data.wiremap) subtests.push({ type: "wiremap" });
    if (this.props.results.data.fiberlengthloss) subtests.push({ type: "fiberlengthloss" });
    if (this.props.results.data.poeload) subtests.push({ type: "poeload" });
    if (this.props.results.data.ping4) subtests.push({ type: "ping4" });
    if (this.props.results.data.ping6) subtests.push({ type: "ping6" });
    if (this.props.results.data.traceroute4)
      subtests.push({ type: "traceroute4" });
    if (this.props.results.data.traceroute6)
      subtests.push({ type: "traceroute6" });
    if (this.props.results.data.netscan) subtests.push({ type: "netscan" });
    if (this.props.results.data.maxthroughput)
      subtests.push({ type: "maxthroughput" });
    if (this.props.results.data.uptime) subtests.push({ type: "uptime" });
    if (this.props.results.data.customdata)
      subtests.push({ type: "customdata" });
    if (this.props.results.data.cabledata) subtests.push({ type: "cabledata" });
    if (this.props.results.data.webdata) subtests.push({ type: "webdata" });
    if (this.props.results.data.voipdata) subtests.push({ type: "voipdata" });
    if (this.props.results.data.videodata) subtests.push({ type: "videodata" });
    if (this.props.results.data.cctvdata) subtests.push({ type: "cctvdata" });

    if (!this.props.results.data.qualification) {
      if (
        subtests.length > 1 &&
        this.props.results.data.subtests.hasOwnProperty("stats")
      )
        subtests.push({ type: "stats" });
      else if (
        subtests.length == 1 &&
        subtests[0].type != "wiremap" &&
        this.props.results.data.subtests.hasOwnProperty("stats")
      )
        subtests.push({ type: "stats" });
    }
    const hasSubtestDropdown =
      results.data &&
      results.data.testedcabletype !== "Fiber" &&
      results.data.testedcabletype !== "FiberCable";

    return (
      <Paper
        className={`${classes.paper} ${
          results.data &&
          results.data.status &&
          results.data.status.toLowerCase() === "passed"
            ? classes.success
            : results.data &&
              results.data.status &&
              (results.data.status.toLowerCase() === "failed" ||
                results.data.status.toLowerCase() === "aborted")
            ? classes.fail
            : classes.unknown
        }`}
      >
        <Grid container spacing={16}>
          <Grid
            className={classes.resultNav}
            item
            xs={2}
            sm={2}
            md={1}
            lg={1}
            xl={1}
          >
            <div className={classes.nav}>
              <Button
                color="#FF643B"
                fab
                className={classes.back}
                mini
                disabled={previousTestId === null}
                component={Link}
                to={`/results/${job.id}/${previousTestId}`}
              >
                <Icon>arrow_upward</Icon>
              </Button>
              &nbsp;
              <Button
                color="#FF643B"
                fab
                className={classes.forward}
                mini
                disabled={nextTestId === null}
                component={Link}
                to={`/results/${job.id}/${nextTestId}`}
              >
                <Icon>arrow_downward</Icon>
              </Button>
            </div>
          </Grid>
          <Grid
            className={`${classes.resultBar} ${classes.resultNameBar}`}
            item
            xs={2}
            sm={2}
            md={3}
            lg={3}
            xl={3}
          >
            <Typography
              className={`${classes.headerText} ${classes.resultNameText} ${classes.signaltekHeaderText}`}
            >
              {results.data ? results.data.name : ""}
            </Typography>
          </Grid>
          <Grid
            className={`${classes.resultBar} ${classes.resultStatusBar}`}
            item
            xs={2}
            sm={2}
            lg={2}
            md={2}
            xl={2}
          >
            <Typography className={classes.status} type="button" gutterBottom>
              {/* {results.data.status}&nbsp;<Icon>{results.data.status === 'Pass' ? 'check_circle' : 'cancel'}</Icon> */}
              {results.data &&
                results.data.status &&
                translate(results.data.status.toLowerCase())}
            </Typography>
          </Grid>
          <Grid
            className={`${classes.resultBar} ${classes.resultCountBar}`}
            item
            xs={2}
            sm={2}
            lg={2}
            md={2}
            xl={2}
          >
            <Typography
              className={`${classes.headerText} ${classes.resultCountText} ${classes.signaltekHeaderText}`}
            >
              {currentTestIndex && total
                ? `${translate("general_test")} ${currentTestIndex} ${translate(
                    "general_of"
                  )} ${total}`
                : ""}
            </Typography>
          </Grid>
          <Grid
            className={`${classes.resultBarDropDown} ${classes.resultDropdownBar} ${classes.signaltekDropdownBar} ${
              hasSubtestDropdown ? "" : classes.resultDropdownHidden
            }`}
            item
            xs={2}
            sm={2}
            lg={2}
            md={2}
            xl={2}
          >
            {hasSubtestDropdown && (
                <Select
                  value={subtest}
                  renderValue={() => this.renderValue(translate, subtest)}
                  onChange={e => this.props.onChange(this.getSubtestType(e.target.value))}
                  autoWidth={true}
                  className={`${classes.resultsDD} ${classes.signaltekResultsDD}`}
                >
                  <MenuItem key={-1} value={"Summary"}>
                    {translate("summary")}
                  </MenuItem>
                  {subtests.map((tab, index) => {
                    // return <Tab key={index} label={tab} />;
                    return (
                      <MenuItem
                        key={index}
                        value={infoData.find(o => o.id === tab.type).value}
                      >
                        {job.deviceid !== "signaltek10g" && tab.type === "fiberlengthloss" ? (isNavitek ? translate("fiberlength") : translate("fiberqualification")) :  translate(infoData.find(o => o.id === tab.type).id)}
                      </MenuItem>
                    );
                  })}
                  {results.data &&
                    results.data.othersubtests &&
                    results.data.othersubtests.map((subtest, index) => {
                      if (subtest.subtesttype.toLowerCase() !== "headroom")
                        return (
                          <MenuItem key={index} value={subtest.subtesttype}>
                            {translate(subtest.subtesttype)}
                          </MenuItem>
                        );
                    })}{" "}
                </Select>
              )}
          </Grid>
          <Grid
            className={classes.resultActions}
            item
            xs={1}
            sm={1}
            lg={1}
            md={1}
            xl={1}
          >
            <Tooltip
              title={translate("tooltip_chart_settings")}
              disableTriggerFocus={true}
            >
              <Button
                aria-label="Chart Settings"
                aria-owns={anchorEl ? "chart-settings-menu" : null}
                aria-haspopup="true"
                className={`${classes.chartSettings} ${classes.compactActionButton}`}
                onClick={this.handleClick}
              >
                <Icon color="#FFFFFF">insert_chart</Icon>
              </Button>
            </Tooltip>
            {subtest === "Wiremap" ? (
              <Menu
                id="chart-settings-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
              >
                <MenuItem className={classes.menuItem}>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <RadioGroup
                      aria-label="wiremapStandard"
                      name="wiremapStandard"
                      className={classes.group}
                      value={wiremapStandard}
                      onChange={handleWiremapStandardChange}
                    >
                      <FormControlLabel
                        value="Standard"
                        control={<Radio />}
                        label={translate("chart_line_standard")}
                      />
                      <FormControlLabel
                        value="568A"
                        control={<Radio />}
                        label={translate("568-A")}
                      />
                      <FormControlLabel
                        value="568B"
                        control={<Radio />}
                        label={translate("568-B")}
                      />
                      <FormControlLabel
                        value="TERA"
                        control={<Radio />}
                        label={translate("TERA")}
                      />
                    </RadioGroup>
                  </FormControl>
                </MenuItem>
                <MenuItem className={classes.menuItem}>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormLabel
                      component="legend"
                      className={classes.radiogroup}
                    >
                      {translate("chart_measurement_unit")}
                    </FormLabel>
                    <RadioGroup
                      aria-label="chartLine"
                      name="chartLine"
                      className={classes.group}
                      value={
                        chartMeasurementUnit ? chartMeasurementUnit : "meters"
                      }
                      onChange={handleChartMeasurementUnitChange}
                    >
                      <FormControlLabel
                        value="meters"
                        control={<Radio />}
                        label={translate("chart_measurement_unit_meter")}
                      />
                      <FormControlLabel
                        value="feet"
                        control={<Radio />}
                        label={translate("chart_measurement_unit_feet")}
                      />
                    </RadioGroup>
                  </FormControl>
                </MenuItem>
              </Menu>
            ) : subtest === "Uptime" ? (
              <Menu
                id="chart-settings-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
              >
                <MenuItem className={classes.menuItem}>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormLabel
                      component="legend"
                      className={classes.radiogroup}
                    >
                      {translate("chart_measurement")}
                    </FormLabel>
                    <RadioGroup
                      aria-label="chartLine"
                      name="chartLine"
                      className={classes.group}
                      value={chartMeasurementType}
                      onChange={handleChartMeasurementTypeChange}
                    >
                      <FormControlLabel
                        value="events"
                        control={<Radio />}
                        label={translate("chart_measurement_unit_events")}
                      />
                      <FormControlLabel
                        value="errors"
                        control={<Radio />}
                        label={translate("chart_measurement_unit_errors")}
                      />
                    </RadioGroup>
                  </FormControl>
                </MenuItem>
              </Menu>
            ) : this.props.results.data.qualification && this.props.impersonating ? (
              <Menu
                id="chart-settings-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
              >
                <MenuItem className={classes.menuItem}>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormLabel
                      component="legend"
                      className={classes.radiogroup}
                    >
                      {translate("chart_line_style")}
                    </FormLabel>
                    <RadioGroup
                      aria-label="chartLine"
                      name="chartLine"
                      className={classes.group}
                      value={chartLineStyle}
                      onChange={handleChartLineChange}
                    >
                      <FormControlLabel
                        value="standard"
                        control={<Radio />}
                        label={translate("chart_line_standard")}
                      />
                      <FormControlLabel
                        value="inverted"
                        control={<Radio />}
                        label={translate("chart_line_inverted")}
                      />
                    </RadioGroup>
                  </FormControl>
                </MenuItem>
                <MenuItem className={classes.menuItem}>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormLabel
                      component="legend"
                      className={classes.radiogroup}
                    >
                      {translate("chart_measurements")}
                    </FormLabel>
                    <RadioGroup
                      aria-label="chartLine"
                      name="chartLine"
                      className={classes.group}
                      value={chartMeasurement}
                      onChange={handleChartMeasurementChange}
                    >
                      <FormControlLabel
                        value="auto"
                        control={<Radio />}
                        label={translate("chart_line_standard")}
                      />
                      <FormControlLabel
                        value="log"
                        control={<Radio />}
                        label={translate("chart_line_logarithmic")}
                      />
                    </RadioGroup>
                  </FormControl>
                </MenuItem>
                <MenuItem className={classes.menuItem}>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormLabel
                      component="legend"
                      className={classes.radiogroup}
                    >
                      {translate("measurement_unit")}
                    </FormLabel>
                    <RadioGroup
                      aria-label="chartLine"
                      name="chartLine"
                      className={classes.group}
                      value={chartMeasurementUnit}
                      onChange={handleChartMeasurementUnitChange}
                    >
                      <FormControlLabel
                        value="meters"
                        control={<Radio />}
                        label={translate("chart_measurement_unit_meter")}
                      />
                      <FormControlLabel
                        value="feet"
                        control={<Radio />}
                        label={translate("chart_measurement_unit_feet")}
                      />
                    </RadioGroup>
                  </FormControl>
                </MenuItem>
              </Menu>
            ) : (
              <Menu
                id="chart-settings-menu"
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={this.handleClose}
              >
                <MenuItem className={classes.menuItem}>
                  <FormControl
                    component="fieldset"
                    className={classes.formControl}
                  >
                    <FormLabel
                      component="legend"
                      className={classes.radiogroup}
                    >
                      {translate("measurement_unit")}
                    </FormLabel>
                    <RadioGroup
                      aria-label="chartLine"
                      name="chartLine"
                      className={classes.group}
                      value={chartMeasurementUnit}
                      onChange={handleChartMeasurementUnitChange}
                    >
                      <FormControlLabel
                        value="meters"
                        control={<Radio />}
                        label={translate("chart_measurement_unit_meter")}
                      />
                      <FormControlLabel
                        value="feet"
                        control={<Radio />}
                        label={translate("chart_measurement_unit_feet")}
                      />
                    </RadioGroup>
                  </FormControl>
                </MenuItem>
              </Menu>
            )}
            <Tooltip
              title={translate("tooltip_attach_files")}
              disableTriggerFocus={true}
            >
              <Button
                aria-label="Attach Files"
                aria-owns={anchorEl ? "chart-settings-menu" : null}
                aria-haspopup="true"
                className={`${classes.chartSettings} ${classes.compactActionButton} ${
                  results && results.data && results.data.attachmentexists
                    ? classes.attachmentExists
                    : ""
                }`}
                onClick={this.showAttachments}
              >
                <Icon color="#FFFFFF">attach_file</Icon>
              </Button>
            </Tooltip>
          </Grid>
        </Grid>
        {$jobAttachmentsModal}
        {$fileUploadModal}
      </Paper>
    );
  }
}

export default withStyles(styles)(SignaltekResultsHeader);
